import React, { useState, useEffect } from "react";
import { fetchLicenses, createLicense, updateLicense, deleteLicense } from "../../../../../services/experienceService";

const LicenseList = ({ profileId, initialLicenses }) => {
    const [licenses, setLicenses] = useState(initialLicenses || []);
    const [tempLicense, setTempLicense] = useState({ title: "", license_number: "", issue_date: "" });
    const [loading, setLoading] = useState(false);
  

    return (
        <>
            <div className="experience-block">

                {/* Header Row */}
                <div className="experience-header-row">
                    <h3 className="experience-title">Licenses</h3>

                </div>

                
                {/* No Licenses Fallback */}
                {licenses.length === 0 && (
                    <p className="no-licenses">No licenses listed.</p>
                )}

                {/* Existing Licenses */}
                {licenses.map((license, index) => (
                    <div key={index} className="experience-license-card">

                        <div className="license-field">
                            <span className="license-label">Title:</span> {license.title}
                        </div>
                        <div className="license-field">
                            <span className="license-label">Number:</span> {license.license_number}
                        </div>
                        <div className="license-field">
                            <span className="license-label">Issue Date:</span> {license.issue_date}
                        </div>
                    </div>

                ))}


            </div>
        </>

    );
};

export default LicenseList;